(function () {
  'use strict';

  function initHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('lux-header--scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initReveal() {
    var items = document.querySelectorAll('.lux-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initAnnouncement() {
    var wrap = document.querySelector('[data-lux-announcement]');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.lux-topbar__slide, .lux-announcement__slide');
    if (slides.length < 2) return;
    var index = 0;
    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 3400);
  }

  function msUntilCutoff(hour) {
    var now = new Date();
    var end = new Date(now);
    end.setHours(hour, 0, 0, 0);
    if (end.getTime() <= now.getTime()) {
      end.setDate(end.getDate() + 1);
    }
    return end.getTime() - now.getTime();
  }

  function formatCountdown(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    return (
      String(h).padStart(2, '0') + 'h ' +
      String(m).padStart(2, '0') + 'm ' +
      String(s).padStart(2, '0') + 's'
    );
  }

  function initDeliveryCountdown() {
    var els = document.querySelectorAll('[data-lux-delivery-countdown]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
        if (isNaN(hour)) hour = 14;
        el.textContent = formatCountdown(msUntilCutoff(hour));
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-lux-counter]');
    if (!counters.length) return;
    function animate(el) {
      var target = parseInt(el.getAttribute('data-lux-counter'), 10) || 0;
      var suffix = el.getAttribute('data-lux-suffix') || '';
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1800, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.floor(target * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) {
      counters.forEach(animate);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { observer.observe(el); });
  }

  function initCountdown() {
    var container = document.querySelector('[data-lux-countdown]');
    if (!container) return;
    var endDate = container.getAttribute('data-lux-countdown');
    if (!endDate) return;
    var end = new Date(endDate).getTime();
    function update() {
      var diff = Math.max(0, end - Date.now());
      var map = {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        mins: Math.floor((diff % 3600000) / 60000),
        secs: Math.floor((diff % 60000) / 1000)
      };
      Object.keys(map).forEach(function (key) {
        var el = container.querySelector('[data-unit="' + key + '"]');
        if (el) el.textContent = String(map[key]).padStart(2, '0');
      });
    }
    update();
    setInterval(update, 1000);
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-lux-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if (!id || !window.routes) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            btn.textContent = 'Added';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            btn.textContent = original;
            btn.disabled = false;
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initReveal();
    initAnnouncement();
    initDeliveryCountdown();
    initCounters();
    initCountdown();
    initQuickAdd();
  });
})();
